export const initFetchParams = {
  pageNum: 1,
  limit: 10,
};
